import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LearnId = Brand<number, 'TryThisId'>;
export const LearnId = createBranded<LearnId>();
